export const iconFontAwesomeDevicesHardwarePrint = (
	<i className="fa-solid fa-print"></i>
);
